export default {
	licitaciones:[
		
		{
			"id": "One",
			"numeroLicitacion": "MR-DG-N1-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N1_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N1_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N1_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N1_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Two",
			"numeroLicitacion": "MR-DG-N2-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N2_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N2_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N2_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N2_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Three",
			"numeroLicitacion": "MR-DG-N3-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N3_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N3_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N3_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N3_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Four",
			"numeroLicitacion": "MR-DG-N4-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N4_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N4_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N4_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N4_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Five",
			"numeroLicitacion": "MR-DG-N5-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N5_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N5_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N5_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Six",
			"numeroLicitacion": "MR-DG-N6-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N6_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N6_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N6_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N6_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Seven",
			"numeroLicitacion": "MR-DG-N7-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N7_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N7_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N7_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Eight",
			"numeroLicitacion": "MR-DG-N8-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N8_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N8_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N8_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Nine",
			"numeroLicitacion": "MR-DG-N9-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N9_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N9_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N9_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Ten",
			"numeroLicitacion": "MR-DG-N10-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N10_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N10_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N10_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N10_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Eleven",
			"numeroLicitacion": "MR-DG-N11-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N11_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N11_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N11_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N11_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Twelve",
			"numeroLicitacion": "MR-DG-N12-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N12_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N12_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N12_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Thirteen",
			"numeroLicitacion": "MR-DG-N13-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N13_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N13_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N13_2019/propuestas.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N13_2019/fallo.pdf",
			"anulacion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N13_2019/anulada.pdf",
			"administrativa": ""
		},
		{
			"id": "Fourteen",
			"numeroLicitacion": "MR-DG-N14-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N14_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N14_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N14_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Fifteen",
			"numeroLicitacion": "MR-DG-N15-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N15_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N15_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N15_2019/propuestas.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Sixteen",
			"numeroLicitacion": "MR-DG-N16-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N16_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N16_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N16_2019/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N16_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Seventeen",
			"numeroLicitacion": "Enajenación de Bienes Muebles No. 1",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/I_MR_DG_1_2019/convocatoria.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/I_MR_DG_1_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/I_MR_DG_1_2019/propuesta.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/I_MR_DG_1_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Eighteen",
			"numeroLicitacion": "MR-DG-N17-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N17_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N17_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N17_2019/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N17_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N17_2019/administrativa.pdf"
		},
		{
			"id": "Nineteen",
			"numeroLicitacion": "Invitación a cuando menos Tres MR-DG-N18-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N18_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N18_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N18_2019/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N18_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Twenty",
			"numeroLicitacion": "MR-DG-N19-2019",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N19_2019/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N19_2019/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N19_2019/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2019/E_MR_DG_N19_2019/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyOne",
			"numeroLicitacion": "MR-DG-N1-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N1_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N1_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N1_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N1_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyTwo",
			"numeroLicitacion": "MR-DG-N2-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N2_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N2_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N2_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N2_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyThree",
			"numeroLicitacion": "MR-DG-N3-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N3_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N3_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N3_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N3_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyFour",
			"numeroLicitacion": "MR-DG-N4-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N4_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N4_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N4_2020/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyFive",
			"numeroLicitacion": "MR-DG-N5-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N5_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N5_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N5_2020/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentySix",
			"numeroLicitacion": "Invitación a cuando menos tres MR-DG-N6-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N6_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N6_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N6_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N6_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentySeven",
			"numeroLicitacion": "MR-DG-N7-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N7_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N7_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N7_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N7_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyEight",
			"numeroLicitacion": "MR-DG-N8-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N8_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N8_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N8_2020/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "TwentyNine",
			"numeroLicitacion": "MR-DG-N9-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N9_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N9_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N9_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N9_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Thirty",
			"numeroLicitacion": "MR-DG-N10-2020",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N10_2020/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N10_2020/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N10_2020/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2020/E_MR_DG_N10_2020/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyOne",
			"numeroLicitacion": "MR-DG-N1-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N1_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N1_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N1_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N1_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyTwo",
			"numeroLicitacion": "MR-DG-N2-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N2_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N2_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N2_2021/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyThree",
			"numeroLicitacion": "MR-DG-N3-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N3_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N3_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N3_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N3_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyFour",
			"numeroLicitacion": "MR-DG-N4-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N4_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N4_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N4_2021/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyFive",
			"numeroLicitacion": "MR-DG-N5-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N5_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N5_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N5_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N5_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtySix",
			"numeroLicitacion": "MR-DG-N6-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N6_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N6_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N6_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N6_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtySeven",
			"numeroLicitacion": "MR-DG-N7-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N7_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N7_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N7_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N7_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyEight",
			"numeroLicitacion": "MR-DG-N8-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N8_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N8_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N8_2021/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N8_2021/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "ThirtyNine",
			"numeroLicitacion": "MR-DG-N9-2021",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N9_2021/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N9_2021/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2021/E_MR_DG_N9_2021/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Forty",
			"numeroLicitacion": "MR-DG-N1-2022",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N1_2022/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N1_2022/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N1_2022/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N1_2022/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyOne",
			"numeroLicitacion": "MR-DG-N2-2022",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N2_2022/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N2_2022/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N2_2022/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyTwo",
			"numeroLicitacion": "MR-DG-N3-2022",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N3_2022/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N3_2022/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N3_2022/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyThree",
			"numeroLicitacion": "MR-DG-N4-2022",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N4_2022/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N4_2022/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N4_2022/proposiciones.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyFour",
			"numeroLicitacion": "MR-DG-N5-2022",
			"base":"http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N5_2022/bases.pdf",
			"aclaracion": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N5_2022/aclaraciones.pdf",
			"propuesta": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N5_2022/proposiciones.pdf",
			"fallo": "http://transparencia.hidalgo.gob.mx/descargables/ENTIDADES/MINJHRehilete/48_Fracciones/XXVIII/LICITACIONES_2022/E_MR_DG_N5_2022/fallo.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyFive",
			"numeroLicitacion": "MR-DG-N6-2022 ",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N6_2022/bases.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N6_2022/aclaraciones.pdf",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N6_2022/Presentacion-y-Apertura-de-propuestas.PDF",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N6_2022/Fallo.PDF",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortySix",
			"numeroLicitacion": "MR-DG-N7-2022",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N7_2022/Bases.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N7_2022/Aclaraciones.PDF",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N7_2022/APERTURA.PDF",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N7_2022/FALLO.PDF",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortySeven",
			"numeroLicitacion": "MR-DG-N8-2022",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N8_2022/BASES_MR_DG_N8_2022.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N8_2022/ACLARACIONES_MR_DG_N8.PDF",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N8_2022/PRESENTACION_Y_APERTURA_MR-DG-N8-2022.PDF",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyEight",
			"numeroLicitacion": "MR-DG-N9-2022",
			"base":"/PDF/Licitaciones/Bases%20MR-DG-N9-2022.pdf",
			"aclaracion": "/PDF/Licitaciones/ACLARACIONES%20MR-DG-N9-2022%20%281%29.PDF",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N9_2022/PRESENTACION_Y_APERTURA_DE_PROPUESTAS_MR_DG_N9_2022.pdf",
			"fallo": "",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FortyNine",
			"numeroLicitacion": "MR-DG-N10-2022",
			"base":"/PDF/Licitaciones/CONVOCATORIA%20CAFETERI%CC%81A%20Y%20PASTES%20.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N10_2022/ACLARACIONES.PDF",
			"propuesta": "/PDF/Licitaciones/ACTA%20DE%20PRESENTACIA%CC%83_N%20Y%20APERTURA%20MR-DG-N10-2022.PDF",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N10_2022/FALLO_N10.PDF",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Fifty",
			"numeroLicitacion": "MR-DG-N11-2022",
			"base":"/PDF/Licitaciones/CONVOCATORIA%20SOUVENIRS%20Y%20CHURRER%C3%8DA.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N11_2022/ACLARACIONES.PDF",
			"propuesta": "/PDF/Licitaciones/ACTA%20DE%20PRESENTACIA%CC%83_N%20Y%20APERTURA%20MR-DG-N11-2022.PDF",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N11_2022/FALLO_N11.PDF",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyOne",
			"numeroLicitacion": "MR-DG-N12-2022",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/Bases_N12.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/JUNTA_DE_ACLARACIONES_N12.pdf",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/PRESENTACION_Y_APERTURA_N12.pdf",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/FALLO_N12.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyTwo",
			"numeroLicitacion": "MR-DG-N12-2022",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/Bases_N12.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/JUNTA_DE_ACLARACIONES_N12.pdf",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/PRESENTACION_Y_APERTURA_N12.pdf",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2022/Licitaciones/E_MR_DG_N12_2022/FALLO_N12.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyThree",
			"numeroLicitacion": "Licitación Pública MR-DG-N1-2023 - Impulsando a Descubrir",
			"convocatoria":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N1-2023/1_CONVOCATORIA_MR-DG-N1-2023.pdf",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N1-2023/2_BASES_MR-DG-N1-2023.pdf",
			"aclaracion": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N1-2023/3_ACLARACIONES_MR-DG-N1-2023.pdf",
			"apertura":"",
			"propuesta": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N1-2023/4_APERTURA_MR-DG-N1-2023.pdf",
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N1-2023/5_FALLO_MR-DG-N1-2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyFour",
			"numeroLicitacion":"Licitación Pública MR-DG-N2-2023 - Vales de Despensa y Ayuda de Útiles Escolares",
			"convocatoria":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N2-2023/1_CONVOCATORIA_MR-DG-N2-2023.pdf",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N2-2023/2_BASES_MR-DG-N2-2023.pdf",
			"aclaracion":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N2-2023/3_ACLARACIONES_MR-DG-N2-2023.pdf",
			"apertura":"",
			"propuesta":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N2-2023/4_APERTURA_MR-DG-N2-2023.pdf" ,
			"fallo": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/1T/MR-DG-N2-2023/5_FALLO_MR-DG-N2-2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyFive",
			"numeroLicitacion":"Licitación Pública MR-DG-N3-2023 - Impulsando a Descubrir Segundo Procedimiento",
			"convocatoria":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/2T/MR-DG-N3-2023/CONVOCATORIA_MR-DG-N3-2023.pdf",
			"base":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/2T/MR-DG-N3-2023/Bases_Licitaci%C3%B3n_MR-DG-N3-2023.pdf",
			"aclaracion":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/2T/MR-DG-N3-2023/JUNTA_DE_ACLARACIONES.pdf",
			"apertura":"",
			"propuesta":"http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/48Fracciones/XXVIII/2023/2T/MR-DG-N3-2023/PRESENTACION_Y_APERTURA_DE_PROPUESTAS.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftySix",
			"numeroLicitacion":"Licitación Pública MR-DG-N4-2023 - Vestuario y Uniformes",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n4_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n4_2023.pdf",
			"aclaracion":"/PDF/Licitaciones/aclaraciones_mr_dg_n4_2023.pdf",
			"apertura":"",
			"propuesta":"/PDF/Licitaciones/proposiciones_mr_dg_n4_2023.pdf" ,
			"fallo":"/PDF/Licitaciones/fallo_mr_dg_n4_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftySeven",
			"numeroLicitacion":"Licitación Pública MR-DG-N5-2023 - Vestuario y Uniformes, Segundo Procedimiento",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n5_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n5_2023.pdf",
			"aclaracion":"/PDF/Licitaciones/aclaraciones_mr_dg_n5_2023.pdf",
			"apertura":"",
			"propuesta":"/PDF/Licitaciones/proposiciones_mr_dg_n5_2023.pdf" ,
			"fallo":"/PDF/Licitaciones/fallo_mr_dg_n5_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyEight",
			"numeroLicitacion":"Invitación a Cuando Menos Tres Personas MR-DG-N6-2023",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/invitacion_mr_dg_n6_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n6_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n6_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n6_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "FiftyNine",
			"numeroLicitacion":"Invitación a Cuando Menos Tres Personas MR-DG-N8-2023",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/bases_mr_dg_n8_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n8_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n8_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n8_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Sixty",
			"numeroLicitacion":"Licitación Pública MR-DG-N7-2023",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n7_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n7_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n7_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n7_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n7_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyOne",
			"numeroLicitacion":"Licitación Pública MR-DG-N9-2023",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n9_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n9_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n9_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n9_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n9_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyTwo",
			"numeroLicitacion":"Invitación a Cuando Menos Tres Personas MR-DG-N10-2023",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/bases_mr_dg_n10_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n10_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n10_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n10_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyThree",
			"numeroLicitacion":"Licitación Pública MR-DG-N11-2023",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n11_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n11_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n11_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n11_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n11_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyFour",
			"numeroLicitacion":"Licitación Pública MR-DG-N12-2023",
			"convocatoria":"../PDF/Licitaciones/convocatoria_mr_dg_n12_2023.pdf",
			"base":"../PDF/Licitaciones/bases_mr_dg_n12_2023.pdf",
			"aclaracion":"../PDF/Licitaciones/aclaracion_mr_dg_n12_2023.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/proposiciones_mr_dg_n12_2023.pdf" ,
			"fallo":"../PDF/Licitaciones/fallo_mr_dg_n12_2023.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyFive",
			"numeroLicitacion":"Licitación Pública MR-DG-N1-2024",
			"convocatoria":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Convocatoria_MR_DG_N1_2024.pdf",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N1_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N1_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N1_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N1_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtySix",
			"numeroLicitacion":"Licitación Pública MR-DG-N2-2024 Segundo Procedimiento",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N2_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N2_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N2_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N2_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtySeven",
			"numeroLicitacion":"Licitación Pública MR-DG-N3-2024",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N3_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N3_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N3_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N3_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyEight",
			"numeroLicitacion":"Licitación Pública MR-DG-N4-2024",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N4_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N4_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N4_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N4_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyNine",
			"numeroLicitacion":"Licitación Pública MR-DG-N5-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N5_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N5_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N5_2024.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SixtyNine",
			"numeroLicitacion":"Licitación Pública MR-DG-N6-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N6_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N6_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N6_2024.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Seventy",
			"numeroLicitacion":"Licitación Pública MR-DG-N7-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N7_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N7_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N7_2024.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyOne",
			"numeroLicitacion":"Licitación Pública MR-DG-N8-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N8_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N8_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N8_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N8_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyTwo",
			"numeroLicitacion":"Licitación Pública MR-DG-N9-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N9_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N9_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N9_2024.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyThree",
			"numeroLicitacion":"Licitación Pública MR-DG-N10-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N10_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N10_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N10_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N10_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyFour",
			"numeroLicitacion":"Licitación Pública MR-DG-N11-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N11_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N11_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N11_2024.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyFive",
			"numeroLicitacion":"Licitación Pública MR-DG-N12-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N12_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N12_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N12_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N12_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventySix",
			"numeroLicitacion":"Licitación Pública MR-DG-N13-2024 ",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Bases_MR_DG_N13_2024.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Aclaraciones_MR_DG_N13_2024.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Proposiciones_MR_DG_N13_2024.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2024/Fallo_MR_DG_N13_2024.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventySeven",
			"numeroLicitacion":"Licitación Pública MR-DG-N1-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N1_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N1_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N1_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N1_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyEight",
			"numeroLicitacion":"Licitación Pública MR-DG-N2-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N2_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N2_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N2_2025.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "SeventyNine",
			"numeroLicitacion":"Licitación Pública MR-DG-N3-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N3_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N3_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N3_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N3_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Eighty",
			"numeroLicitacion":"Licitación Pública MR-DG-N4-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N4_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N4_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N4_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N4_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyOne",
			"numeroLicitacion":"Licitación Pública MR-DG-N5-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N5_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N5_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N5_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N5_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyTwo",
			"numeroLicitacion":"Licitación Pública MR-DG-N6-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N6_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N6_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N6_2025.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyThree",
			"numeroLicitacion":"Licitación Pública MR-DG-N7-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N7_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N7_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N7_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N7_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyFour",
			"numeroLicitacion":"Licitación Pública MR-DG-N8-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N8_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N8_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N8_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N8_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyFive",
			"numeroLicitacion":"Invitación a Cuando Menos Tres Personas MR-DG-N9-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N9_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N9_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N9_2025.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightySix",
			"numeroLicitacion":"Licitación Pública MR-DG-N10-2025",
			"convocatoria":"",
			"base":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Bases_MR_DG_N10_2025.pdf",
			"aclaracion":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Aclaraciones_MR_DG_N10_2025.pdf",
			"apertura":"",
			"propuesta":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Proposiciones_MR_DG_N10_2025.pdf" ,
			"fallo":"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Licitaciones/2025/Fallo_MR_DG_N10_2025.pdf",
			"anulacion": "",
			"administrativa": ""
		},
	],
	licitaciones2:[
		{
			"id": "EightySeven",
			"numeroLicitacion":"Licitación Pública MR-DG-N1-2026",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N1_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N1_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N1_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N1_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyEight",
			"numeroLicitacion":"Licitación Pública MR-DG-N2-2026 Segundo Procedimiento",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N2_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N2_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N2_2026.pdf" ,
			"fallo":"",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "EightyNine",
			"numeroLicitacion":"Licitación Pública MR-DG-N3-2026",
			"convocatoria":"",
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N3_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N3_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N3_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N3_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "Ninety",
			"numeroLicitacion":"Licitación Pública MR-DG-N4-2026",	
			"convocatoria":"",
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N4_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N4_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N4_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N4_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "NinetyOne",
			"numeroLicitacion":"Licitación Pública MR-DG-N5-2026",	
			"convocatoria":"",	
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N5_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N5_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N5_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N5_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "NinetyTwo",
			"numeroLicitacion":"Licitación Pública MR-DG-N6-2026",	
			"convocatoria":"",	
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N6_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N6_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N6_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N6_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "NinetyThree",
			"numeroLicitacion":"Licitación Pública MR-DG-N7-2026",	
			"convocatoria":"",	
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N7_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N7_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N7_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N7_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "NinetyFour",
			"numeroLicitacion":"Licitación Pública MR-DG-N8-2026",	
			"convocatoria":"",	
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N8_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N8_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N8_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N8_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
		{
			"id": "NinetyFive",
			"numeroLicitacion":"Invitación a cuando menos tres personas MR-DG-N9-2026",	
			"convocatoria":"",
			"base":"../PDF/Licitaciones/2026/Bases_MR_DG_N9_2026.pdf",
			"aclaracion":"../PDF/Licitaciones/2026/Aclaraciones_MR_DG_N9_2026.pdf",
			"apertura":"",
			"propuesta":"../PDF/Licitaciones/2026/Proposiciones_MR_DG_N9_2026.pdf" ,
			"fallo":"../PDF/Licitaciones/2026/Fallo_MR_DG_N9_2026.pdf",
			"anulacion": "",
			"administrativa": ""
		},
	],
}
